import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoComplaint = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 116,
	height: 134,
	viewBox: "0 0 116 134",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_26373_3558)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M94.7888 11.8035C95.7986 10.852 95.8625 6 95.8625 6C95.8625 6 96.0063 11.1061 96.6487 11.6493C97.2716 12.1767 101 12.8846 101 12.8846C101 12.8846 97.4419 13.0213 96.78 13.6101C96.3203 14.0183 95.8625 19 95.8625 19C95.8625 19 95.4987 14.565 94.8066 13.9272C94.118 13.2929 91 12.8864 91 12.8864C91 12.8864 94.0115 12.5359 94.7888 11.8035Z",
				fill: "url(#paint0_linear_26373_3558)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_d_26373_3558)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M21.2112 12.8035C20.2014 11.852 20.1375 7 20.1375 7C20.1375 7 19.9937 12.1061 19.3513 12.6493C18.7284 13.1767 15 13.8846 15 13.8846C15 13.8846 18.5581 14.0213 19.22 14.6101C19.6797 15.0183 20.1375 20 20.1375 20C20.1375 20 20.5013 15.565 21.1934 14.9272C21.882 14.2929 25 13.8864 25 13.8864C25 13.8864 21.9885 13.5359 21.2112 12.8035Z",
				fill: "url(#paint1_linear_26373_3558)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter2_d_26373_3558)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M108.273 22.1258C108.878 21.6129 108.918 19 108.918 19C108.918 19 109.005 21.7499 109.389 22.0422C109.763 22.3262 112 22.7072 112 22.7072C112 22.7072 109.864 22.7807 109.468 23.0981C109.193 23.3169 108.918 26 108.918 26C108.918 26 108.699 23.611 108.285 23.2685C107.872 22.9277 106 22.7072 106 22.7072C106 22.7072 107.808 22.52 108.273 22.1258Z",
				fill: "url(#paint2_linear_26373_3558)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter3_d_26373_3558)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M7.7266 23.1258C7.12152 22.6129 7.08197 20 7.08197 20C7.08197 20 6.99526 22.7499 6.61073 23.0422C6.2375 23.3262 4 23.7072 4 23.7072C4 23.7072 6.13572 23.7807 6.53157 24.0981C6.80678 24.3169 7.08197 27 7.08197 27C7.08197 27 7.30063 24.611 7.71533 24.2685C8.12814 23.9277 10 23.7072 10 23.7072C10 23.7072 8.19219 23.52 7.7266 23.1258Z",
				fill: "url(#paint3_linear_26373_3558)"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter4_d_26373_3558)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M70.821 6.03125H43.6602V18.9087H70.821V6.03125Z",
					fill: "#7548F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .5,
					d: "M69.9979 6.36104C69.4478 7.10329 68.1045 7.30931 67.323 7.91883C66.4002 8.64091 66.0551 9.4596 64.8562 9.99904C62.3438 11.1278 59.8442 12.5518 57.4231 13.8717C54.7556 15.3233 52.17 16.8726 49.8359 18.5981C53.1097 18.7617 56.3569 18.5546 59.5585 18.8137C62.432 19.0463 65.5199 19.0027 68.3881 19.0941C68.8319 17.9143 68.5877 16.5763 68.6769 15.3488C68.782 13.9471 69.1654 12.5826 69.5062 11.2032C69.9278 9.47978 70.3154 7.73724 70.3706 6C70.2368 6.19751 70.0711 6.12849 69.8726 6.26547L69.9979 6.36104Z",
					fill: "#8E68F7"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M70.3395 6.2832C70.2185 7.86116 13 110.47 13 110.47L31.1295 102.723L38.4884 119.141L87.5739 26.3071L70.3395 6.2832Z",
					fill: "#7548F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .3,
					d: "M73.7981 12.9808C77.0209 17.7741 75.1339 25.9188 74.3449 31.1199C73.2119 38.6114 69.9137 46.154 66.2725 53.0997C59.6517 65.7329 49.6488 77.9541 40.0578 89.2281C36.5972 93.2994 31.2347 95.7152 26.5571 98.7522C24.6276 100.003 22.9138 101.407 20.9238 102.658C19.9904 103.236 14.9327 106.256 14.9741 107.199C14.8562 107.239 14.7988 107.311 14.8211 107.406C17.8666 107.761 21.8317 104.691 24.5841 103.703C26.7822 102.917 29.9222 101.231 32.3825 101.552C34.776 105.673 35.4429 111.547 38.9864 115.15C39.3889 111.089 43.7426 106.435 45.7049 102.658C48.0092 98.2212 50.6459 93.9493 52.9873 89.5106C54.9221 85.8503 56.6646 82.1401 58.3679 78.4352C59.9607 74.9777 62.4243 71.8526 63.7707 68.2995C68.684 55.3605 77.1887 43.4058 82.7933 30.7705C84.5794 26.7534 83.3784 24.7581 80.2246 21.2858C77.9564 18.7903 74.8058 14.854 73.7959 11.9922V12.9808H73.7981Z",
					fill: "#7548F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M68.1677 13.177C68.3472 16.4646 64.7963 20.3755 63.504 23.4561C61.9653 27.1142 59.7067 30.4932 57.6392 33.9708C53.7304 40.5471 49.6878 46.9396 46.1273 53.6485C39.705 65.7604 32.377 77.5865 26.2988 89.8545C25.4249 91.6151 24.5976 93.3576 23.9414 95.1809C26.096 94.7391 27.8767 91.6055 29.0459 90.2134C30.6068 88.3572 32.0839 85.8745 34.333 84.5366C34.4084 85.3595 33.9518 86.8695 34.848 87.3017C37.0663 88.3657 40.8243 83.9727 41.7364 82.9894C46.1262 78.2736 51.0672 73.7 54.65 68.5605C60.3661 60.3766 66.062 51.3899 68.1656 42.0762C70.3796 32.2644 74.9585 20.453 69.5121 11.2009C69.1585 11.151 69.1531 11.3113 68.8367 11.3856L68.1677 13.177Z",
					fill: "#8E68F7"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M62.7831 27.8057C58.01 31.9905 55.0155 38.8906 52.0815 43.9994C49.3471 48.7492 46.2963 53.1729 43.8774 58.03C41.778 62.2531 39.2157 66.336 37.3245 70.6526C36.4686 72.5958 35.8867 75.035 39.2667 73.0333C42.3961 71.1856 43.8073 67.6389 47.079 65.9612C47.3975 67.2365 46.9611 68.8049 49.0604 68.6509C51.8946 68.4502 55.1418 62.6195 56.1782 60.9565C59.6782 55.3424 61.3528 49.0645 63.9491 43.1658C65.4952 39.651 67.3067 34.9988 66.7057 31.2068C66.5018 29.9294 63.2376 26.3657 62.2925 28.7911L62.7831 27.8057Z",
					fill: "#8E68F7"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M75.5093 14.7608C76.8101 18.2385 73.4917 23.6562 72.33 27.0118C69.7645 34.4184 65.3896 41.7242 61.0571 48.5669C57.7005 53.87 51.8655 62.7674 43.2419 59.4427C41.2137 63.9206 37.9006 67.9399 35.4158 72.2681C32.398 77.5191 29.5904 82.8806 26.8454 88.2356C23.4113 94.9425 19.1383 101.463 15.8008 108.017C18.9854 107.254 21.6709 104.618 24.848 103.482C26.9781 102.721 30.5089 101.226 32.8758 101.547C33.2432 106.079 36.9078 111.011 39.0496 115.084C38.4263 111.861 42.9595 106.739 44.6617 103.93C47.0806 99.9588 49.2352 96.1859 51.0308 92.0318C54.6593 83.6366 59.4962 75.7033 63.7702 67.5364C68.3565 58.7758 72.6518 50.0365 77.7786 41.4332C79.7229 38.1753 81.7394 34.9461 83.2802 31.5566C84.067 29.8374 85.8106 27.5204 85.2532 25.625C84.701 23.721 81.5047 21.1704 79.9756 19.6975C78.7767 18.5401 75.9075 14.3733 74.5313 14.1641L75.5093 14.7608Z",
					fill: "#7548F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .5,
					d: "M42.9486 57.2504C42.6354 58.3993 41.633 59.1543 41.7158 60.4116C41.8114 61.9173 42.7968 64.4085 43.3776 65.9058C44.7337 69.4131 45.9729 72.928 47.2939 76.4704C48.4842 79.6539 49.8487 82.8767 50.5422 86.1038C50.9765 88.1341 50.9191 90.3205 52.2603 92.1597C53.8042 88.6842 56.2944 85.3424 57.7045 81.7501C58.793 78.9754 59.3887 75.9968 60.629 73.255C61.47 71.3904 65.0252 67.8692 64.0174 65.7911C63.4982 64.7122 61.8363 64.4945 60.767 63.8308C58.8992 62.6628 58.4171 61.1368 57.7045 59.424C56.5747 56.7045 55.2643 55.6989 51.9916 54.8781C48.3855 53.9734 44.7793 55.6809 43.1876 58.36C43.1961 58.0574 43.1993 57.7505 43.1929 57.45L42.9486 57.2504Z",
					fill: "#8E68F7"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .5,
					d: "M43.443 57.2506C42.3461 58.3751 41.8003 59.0441 42.2718 60.1665C42.362 60.38 43.4144 60.8865 43.631 61.1955C44.1428 61.9154 44.0387 62.8605 44.3594 63.624C45.4139 66.1194 46.5756 68.5766 47.5429 71.1273C49.654 76.6915 51.4815 82.7357 53.9748 88.0059C54.8859 85.7122 57.9207 83.8868 57.0903 81.5666C56.415 79.6796 54.8572 78.0327 54.1532 76.0788C53.3812 73.9465 52.6676 71.8026 51.7671 69.699C50.5088 66.7725 48.7641 63.8481 46.8092 61.204C45.7993 59.8352 44.2787 57.1932 42.9524 56.8545L43.443 57.2506Z",
					fill: "#8E68F7"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M43.6658 6.03125C43.789 7.61133 101.005 110.22 101.005 110.22L82.879 102.473L75.5212 118.891L26.4336 26.0573L43.6658 6.03125Z",
					fill: "#7548F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .3,
					d: "M40.2052 12.7298C36.9834 17.5253 38.8714 25.6678 39.6593 30.871C40.7924 38.3604 44.0927 45.903 47.7328 52.8467C54.3526 65.483 64.3534 77.701 73.9496 88.9814C77.4082 93.0484 82.7685 95.4621 87.4472 98.4991C89.3766 99.7521 91.0937 101.156 93.0837 102.403C94.0128 102.99 99.0748 106.003 99.0302 106.948C99.1534 106.99 99.2044 107.057 99.1853 107.156C96.1387 107.51 92.1705 104.44 89.4223 103.454C87.2221 102.662 84.0842 100.98 81.6217 101.304C79.2261 105.427 78.5624 111.294 75.0147 114.897C74.6154 110.84 70.2628 106.184 68.2972 102.4C65.9983 97.9724 63.3595 93.6983 61.0138 89.2596C59.0801 85.5993 57.3407 81.8891 55.6343 78.1842C54.0457 74.731 51.579 71.6037 50.2325 68.0507C45.3192 55.1085 36.8135 43.157 31.211 30.5195C29.4228 26.4982 30.6248 24.5072 33.7818 21.0327C36.05 18.5415 39.1995 14.603 40.2073 11.7412V12.7298H40.2052Z",
					fill: "#7548F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M45.8441 12.9285C45.6626 16.214 49.2124 20.1249 50.5047 23.2033C52.0434 26.8657 54.3041 30.2425 56.3727 33.7201C60.2772 40.2964 64.323 46.6868 67.8803 53.3979C74.3047 65.5118 81.6327 77.338 87.712 89.6059C88.5827 91.3623 89.411 93.107 90.0673 94.9302C87.917 94.4906 86.1351 91.3527 84.9628 89.9627C83.405 88.1044 81.929 85.6239 79.6757 84.288C79.6013 85.111 80.0601 86.6231 79.1596 87.0511C76.9413 88.1151 73.1833 83.7199 72.2723 82.7398C67.8856 78.024 62.9415 73.4504 59.3587 68.3131C53.6436 60.1249 47.9466 51.1403 45.8452 41.8266C43.6311 32.0148 40.9446 21.0201 46.3878 11.77C45.5309 11.1934 45.2144 11.9176 45.5309 11.9941L45.8441 12.9285Z",
					fill: "#8E68F7"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M51.2241 27.5518C55.9962 31.7345 58.9917 38.6389 61.93 43.7476C64.6601 48.4995 67.7108 52.9233 70.1298 57.7761C72.2313 62.0024 74.7946 66.0885 76.6848 70.3966C77.5375 72.3419 78.1215 74.7853 74.7394 72.7815C71.6122 70.9339 70.1999 67.3851 66.9303 65.7094C66.6128 66.9847 67.0482 68.5489 64.9457 68.3992C62.1137 68.1995 58.8664 62.3634 57.83 60.7048C54.328 55.0906 52.6534 48.8128 50.0571 42.914C48.5099 39.3981 46.7015 34.7471 47.3015 30.953C47.5022 29.6798 50.7685 26.1119 51.7136 28.5372L51.2241 27.5518Z",
					fill: "#8E68F7"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M43.9985 8.03392C43.6332 9.73824 41.0677 12.2294 39.7722 13.6874C38.1284 15.5351 36.5196 17.4146 34.8227 19.2315C33.3181 20.8466 32.0087 22.6614 30.4265 24.2032C28.1594 26.4013 28.5534 27.0342 30.0602 29.8322C33.6929 36.5603 37.0368 43.3925 42.7805 49.0852C45.9746 52.2539 46.5948 56.5078 48.35 60.2413C50.6373 65.109 53.394 69.7653 55.8459 74.5661C59.7408 82.2064 62.3775 90.1875 66.1419 97.8596C67.8526 101.352 69.5059 104.873 71.1656 108.37C72.1171 110.38 72.8901 112.904 74.4713 114.606C75.9006 113.064 75.2486 109.145 76.0768 107.03C76.6471 105.564 77.1419 101.449 79.2561 100.8C80.9806 100.265 86.7222 102.138 88.4913 102.61C91.1492 103.322 93.8496 104.031 96.3099 105.023C95.933 103.522 93.6786 101.79 92.484 100.469C90.3273 98.0879 87.6577 95.9556 85.2122 93.749C79.6543 88.7295 74.861 84.362 72.648 77.7443C70.7685 72.1281 68.8985 67.2848 65.5281 62.1272C62.0154 56.7616 57.8082 51.7282 55.1132 46.0472C52.8683 41.3059 51.9859 36.1292 50.6692 31.1617C49.7061 27.5216 48.675 23.7965 48.0835 20.1298C47.7554 18.074 47.1352 6.76285 42.7752 7.63147L43.9985 8.03392Z",
					fill: "#7548F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .5,
					d: "M57.0265 30.6681C57.7305 31.0472 58.0374 31.7544 58.4632 32.3459C59.1184 33.258 59.8914 33.7752 60.8216 34.5004C62.5143 35.815 62.6481 37.5406 63.7291 39.1504C65.822 42.2596 67.9851 45.3582 69.7563 48.5746C70.6313 50.1632 72.2209 52.0979 72.5703 53.7906C72.7519 54.6783 71.7601 57.7418 70.8596 58.2473C70.1588 57.6537 69.8062 56.5525 69.3613 55.7943C68.1305 53.6929 66.766 51.6445 65.496 49.5558C63.5093 46.2767 61.9844 42.8733 60.2312 39.538C59.2341 37.6425 58.8147 35.5326 57.8505 33.6329C57.4374 32.8152 56.7334 31.1438 57.0265 30.5693V30.6681Z",
					fill: "#8E68F7"
				}),
				/* @__PURE__ */ _jsxs("g", {
					filter: "url(#filter5_d_26373_3558)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M57.8308 26.7324L30.6758 42.4105V79.8166L57.8308 95.4943L84.9858 79.8166V42.4105L57.8308 26.7324Z",
							fill: "#D9AA04"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M35.582 76.9813V45.2459L57.8263 32.4033L80.0706 45.2459V76.9813L57.8263 89.8242L35.582 76.9813Z",
							fill: "url(#paint4_linear_26373_3558)"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M37.2227 76.0368V46.1914L57.83 34.2939L78.4373 46.1914V76.0368L57.83 87.9347L37.2227 76.0368Z",
							fill: "#D9AA04"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .5,
							d: "M31.3588 42.5089C31.0238 43.5139 33.9091 44.7504 35.9421 44.3095C37.9752 43.8686 57.0864 32.6539 57.5495 31.6506C57.6786 31.3709 57.6993 27.4492 57.5495 27.4492C56.8772 27.4492 31.5225 42.0178 31.3588 42.5089Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .5,
							d: "M84.1816 42.5089C84.5166 43.5139 81.6313 44.7504 79.5982 44.3095C77.5652 43.8686 58.6348 32.5484 57.9909 31.6506C57.6585 31.1868 57.5493 27.4492 57.9909 27.4492C58.6635 27.4492 84.0179 42.0178 84.1816 42.5089Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .37,
							d: "M31.3236 63.7822C31.1414 64.9008 30.6969 79.0602 31.3236 79.1693C31.9504 79.2784 34.8972 77.2595 35.0605 76.332C35.2242 75.4044 35.2788 65.692 35.0605 64.7644C34.8423 63.8368 31.6274 61.9187 31.3236 63.7822Z",
							fill: "#D9AA04"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .37,
							d: "M84.2289 63.7822C84.4111 64.9008 84.856 79.0602 84.2289 79.1693C83.6018 79.2784 80.6553 77.2595 80.4916 76.332C80.3279 75.4044 80.2734 65.692 80.4916 64.7644C80.7099 63.8368 83.9251 61.9187 84.2289 63.7822Z",
							fill: "#D9AA04"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .37,
							d: "M32.0037 79.5564C32.3325 80.0406 56.7881 94.5 57.1566 94.5C57.3417 94.5 57.5873 90.9065 57.5873 90.5056C57.5873 89.3881 35.96 77.9028 35.5816 77.7962C35.0225 77.6391 31.6705 79.0654 32.0037 79.5564Z",
							fill: "#D9AA04"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .37,
							d: "M83.6964 79.9337C83.3675 80.4178 58.4536 94.8296 58.0851 94.8296C58.0051 94.8296 58.0004 90.3576 58.1666 90.1917C58.9571 89.4012 79.5822 77.9024 79.9609 77.7958C80.5197 77.6383 84.0299 79.4422 83.6964 79.9337Z",
							fill: "#D9AA04"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .37,
							d: "M38.1715 75.2392C36.7143 66.9694 37.5266 66.4482 47.7846 62.955C58.0426 59.4618 75.3957 50.4551 76.9188 54.3655C78.4422 58.276 77.9195 74.9143 77.5736 75.8244C77.2276 76.7346 59.3139 87.0286 57.8349 87.053C56.3558 87.077 38.3352 76.1678 38.1715 75.2392Z",
							fill: "#FFF9E4"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .5,
							d: "M77.9927 46.398C77.6308 46.3103 59.0085 35.5474 57.9572 35.6274C56.9601 35.7031 43.9837 41.7717 38.6638 46.3572C37.2451 47.5798 37.7635 65.8391 39.073 65.5026C40.3825 65.1665 41.3581 57.7873 55.7696 53.6415C69.9602 49.559 76.1332 53.0911 77.6726 53.7233C78.1077 53.902 78.8166 46.5973 77.9927 46.398Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .6,
							d: "M35.582 76.9813V45.2459L57.8263 32.4033L80.0706 45.2459V76.9813L78.4336 76.0363C78.4336 76.0363 78.5329 48.4498 77.9396 47.5845C75.8237 44.4972 59.3683 36.9911 56.6674 37.8266C53.9039 38.6814 39.2727 44.9108 37.6358 47.5299C37.0847 48.4117 37.2193 76.0363 37.2193 76.0363L35.582 76.9813Z",
							fill: "#D9AA04"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .5,
							d: "M61.996 49.5751C67.5382 52.1014 75.8865 52.1454 76.6504 51.6638C77.4143 51.1821 77.9225 47.6257 76.7221 47.0255C75.5217 46.4253 66.0105 41.3606 63.5005 41.9063C60.9906 42.4519 61.0164 49.1284 61.996 49.5751Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M30.6758 53.806C30.6758 53.7223 30.9104 43.2562 31.3538 42.5094C31.7973 41.7626 57.2462 27.6502 57.9861 27.4498C58.7264 27.2493 68.2591 32.753 68.2591 32.753L57.8308 26.7324L30.6758 42.4105V53.806Z",
							fill: "#D9AA04"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M67.5547 38.0146C67.5547 38.0146 79.4838 44.8017 79.6471 45.5656C79.8108 46.3295 80.0793 66.839 80.0793 66.839C80.0793 66.839 80.1921 46.1203 80.0793 45.2458C79.9662 44.371 67.5547 38.0146 67.5547 38.0146Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M35.584 62.6379C35.584 62.6379 35.1878 45.4812 35.389 44.9247C35.5902 44.3681 57.8282 32.4033 57.8282 32.4033C57.8282 32.4033 36.3552 44.6791 35.9132 45.4565C35.4709 46.2342 35.584 62.6379 35.584 62.6379Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M30.6758 79.8143L57.8308 95.4923L84.9858 79.8143V71.2943C84.9858 71.2943 84.7588 78.7325 84.2037 79.6593C83.649 80.5862 59.3248 94.7324 58.0854 94.8281C56.8461 94.9238 31.9784 80.1504 31.3269 79.1683C30.6758 78.1861 30.6758 60.7529 30.6758 60.7529V79.8143Z",
							fill: "#D9AA04"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M35.5844 68.8604C35.5844 68.8604 35.5076 76.1796 35.9132 76.7939C36.3192 77.4083 46.8707 83.5002 46.8707 83.5002C46.8707 83.5002 35.4389 77.5906 35.3323 77.2086C35.2257 76.8267 35.5844 68.8604 35.5844 68.8604Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .5,
							d: "M44.7784 83.6455C43.9767 83.6477 41.7309 84.5469 42.2165 85.078C42.6082 85.5065 56.0688 93.6689 57.5959 94.2302C58.0938 94.4132 58.0462 91.2313 57.378 90.2034C57.0917 89.7632 47.2622 83.6393 44.7784 83.6455Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M67.3967 32.9051C66.7452 33.0812 68.9245 35.8243 69.9612 36.0698C70.998 36.3153 72.4166 35.5784 71.9255 35.0738C71.4345 34.5693 68.4062 32.6323 67.3967 32.9051Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M72.2279 35.6268C71.2399 35.8912 73.0623 40.2251 73.8426 40.9959C74.6229 41.767 81.5529 43.1177 81.3939 41.8689C81.2349 40.6201 73.616 35.2554 72.2279 35.6268Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .3,
							d: "M70.3542 83.7166C69.7692 86.2709 69.8631 87.7765 70.1905 87.7929C70.5178 87.8093 82.3924 80.6625 82.7165 80.3482C83.0403 80.0339 80.813 77.9827 79.8963 78.1231C78.9793 78.2635 70.5724 82.7621 70.3542 83.7166Z",
							fill: "#D9AA04"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .3,
							d: "M37.0312 45.9747C36.7445 45.1144 35.8664 45.1195 35.7864 46.0787C35.7064 47.0379 35.5692 64.8203 35.9181 64.8476C36.2669 64.8749 37.0035 64.0019 37.0308 63.5926C37.0585 63.183 37.1676 46.3839 37.0312 45.9747Z",
							fill: "#D9AA04"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .3,
							d: "M78.6356 46.0856C78.5887 46.4243 78.4174 63.2121 78.6356 63.2121C78.8539 63.2121 79.836 62.421 79.836 62.0117C79.836 61.6025 79.5905 45.7306 79.4814 45.6487C79.3723 45.5672 78.6735 45.8117 78.6356 46.0856Z",
							fill: "#D9AA04"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .3,
							d: "M57.8283 34.0158C57.8283 34.3457 48.2596 39.8065 48.0345 39.8065C47.8093 39.8065 47.8911 38.3333 48.1982 38.1285C48.5052 37.9237 57.7599 32.3581 57.8283 32.5426C57.8967 32.7266 57.8283 33.7412 57.8283 34.0158Z",
							fill: "#D9AA04"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M77.5779 78.2581C76.9668 78.2349 74.9028 79.4349 75.0592 80.022C75.2156 80.6091 76.4793 81.2428 76.8147 80.903C77.1501 80.5629 77.978 78.2734 77.5779 78.2581Z",
							fill: "#D9AA04"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M78.3668 78.6714C78.1569 78.8649 77.6989 79.5528 78.1351 79.8886C78.5709 80.2247 79.8535 79.3386 79.664 79.0781C79.4745 78.8177 78.6382 78.4212 78.3668 78.6714Z",
							fill: "#D9AA04"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .3,
							d: "M75.3687 79.4336C74.8598 80.1229 76.947 80.5809 77.2191 80.0007C77.4912 79.4205 77.927 78.1983 77.5847 78.259C77.242 78.3198 75.6458 79.0575 75.3687 79.4336Z",
							fill: "#D9AA04"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M75.0802 79.8525C75.0802 79.8525 75.2504 80.4396 75.8692 80.8027C76.3555 81.0879 76.7742 81.0238 76.8975 80.8125C76.8975 80.8125 76.5178 81.3076 75.8852 81.0126C74.8947 80.5502 75.0802 79.8525 75.0802 79.8525Z",
							fill: "#D9AA04"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .3,
							d: "M78.5985 78.6871C78.1271 79.1949 78.4934 79.9272 78.7582 79.8861C79.023 79.8449 79.812 79.3233 79.6636 79.0756C79.5152 78.8279 78.7018 78.5762 78.5985 78.6871Z",
							fill: "#D9AA04"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M78.3653 78.668C78.3653 78.668 77.9321 79.2634 78.1059 79.6065C78.2798 79.9495 78.5257 79.948 78.5257 79.948C78.5257 79.948 77.9652 80.274 77.8619 79.8917C77.6832 79.2303 78.3653 78.668 78.3653 78.668Z",
							fill: "#D9AA04"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M55.0386 33.8354C53.5759 33.4491 52.3937 34.3967 51.752 35.125C51.1103 35.8532 51.4683 36.2861 52.2747 36.1428C53.0812 35.9987 55.6551 33.998 55.0386 33.8354Z",
							fill: "#D9AA04"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .3,
							d: "M55.0348 33.8331C54.0454 33.4955 52.7937 34.151 52.4005 34.4999C52.0072 34.8487 52.7802 35.8378 53.3128 35.6268C53.8453 35.4158 55.4859 33.987 55.0348 33.8331Z",
							fill: "#D9AA04"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M52.1226 34.7412C52.1226 34.7412 50.4696 35.8238 50.6551 36.3607C50.8407 36.8972 52.8221 35.9187 52.8221 35.9187C52.8221 35.9187 51.7944 36.2537 51.5616 35.7979C51.3288 35.3414 52.1226 34.7412 52.1226 34.7412Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M36.5378 77.1987C35.7593 77.3933 38.0663 78.9775 38.6119 79.0593C39.1576 79.1412 38.6196 77.7516 38.3551 77.5126C38.1612 77.3373 36.9743 77.0896 36.5378 77.1987Z",
							fill: "white"
						})
					]
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_26373_3558",
				x: 87,
				y: 6,
				width: 18,
				height: 21,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_26373_3558"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_26373_3558",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_26373_3558",
				x: 11,
				y: 7,
				width: 18,
				height: 21,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_26373_3558"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_26373_3558",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_d_26373_3558",
				x: 102,
				y: 19,
				width: 14,
				height: 15,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_26373_3558"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_26373_3558",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter3_d_26373_3558",
				x: 0,
				y: 20,
				width: 14,
				height: 15,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_26373_3558"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_26373_3558",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter4_d_26373_3558",
				x: 3,
				y: 0,
				width: 108.004,
				height: 133.141,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 5 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_26373_3558"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_26373_3558",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter5_d_26373_3558",
				x: 26.6758,
				y: 26.7324,
				width: 62.3086,
				height: 76.7617,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_26373_3558"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_26373_3558",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_26373_3558",
				x1: 105.658,
				y1: 12.4993,
				x2: 93.4156,
				y2: 12.4993,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#CA6B34" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6667,
						stopColor: "#FFA933"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#FFBD2B"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_26373_3558",
				x1: 10.342,
				y1: 13.4993,
				x2: 22.5844,
				y2: 13.4993,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#CA6B34" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6667,
						stopColor: "#FFA933"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#FFBD2B"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_26373_3558",
				x1: 114.796,
				y1: 22.5008,
				x2: 107.45,
				y2: 22.5008,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#CA6B34" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6667,
						stopColor: "#FFA933"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#FFBD2B"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_26373_3558",
				x1: 1.20415,
				y1: 23.5008,
				x2: 8.55005,
				y2: 23.5008,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#CA6B34" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6667,
						stopColor: "#FFA933"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#FFBD2B"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_26373_3558",
				x1: 57.8263,
				y1: 27.3435,
				x2: 57.8263,
				y2: 86.6122,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#B2911C" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .1992,
						stopColor: "#E6C345"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .4408,
						stopColor: "#FBE490"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7042,
						stopColor: "#FFF0BA"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .9816,
						stopColor: "#FFF4CC"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#FFFCF0"
					})
				]
			})
		] })
	]
});
export default SvgNoComplaint;
